import { Dialog } from "@headlessui/react";
import { useState } from "react";

const quickRanges = [
  { label: "Last 7 Days", value: "last7" },
  { label: "Last 14 Days", value: "last14" },
  { label: "Last 30 Days", value: "last30" },
];

export default function FilterModal({
  isOpenFilter,
  setFilters,
  filters,
  setIsOpenFilter,
  isAdmin,
}) {
  const [rangeType, setRangeType] = useState("custom");

  const handleDateChange = (e, type) => {
    setRangeType("custom");
    setFilters({
      ...filters,
      dateRange: { ...filters.dateRange, [type]: e.target.value },
    });
  };

  const handleClearFilters = () => {
    setFilters({
      verification: "",
      token: "",
      installationStatus: "",
      dateRange: { start: "", end: "" },
      quickRange: "",
      clearfilter: true,
    });
    setRangeType("custom");
  };

  const handleQuickRange = (value) => {
    const today = new Date();
    let startDate = new Date();

    if (value === "last7") startDate.setDate(today.getDate() - 7);
    if (value === "last14") startDate.setDate(today.getDate() - 14);
    if (value === "last30") startDate.setDate(today.getDate() - 30);

    const toDateString = (date) => date.toISOString().split("T")[0];

    setRangeType(value);
    setFilters({
      ...filters,
      quickRange: value,
      dateRange: {
        start: toDateString(startDate),
        end: toDateString(today),
      },
    });
  };

  const installationOptions = [
    // "Installation Pending",
    "Installation Requested",
    "Installation Planned",
    "Installation Started",
    "Installation Completed",
  ];
  const getFilterCount = () => {
    let count = 0;
    if (filters.verification) count++;
    if (filters.token) count++;
    if (filters.installationStatus) count++;
    if (filters.dateRange.start && filters.dateRange.end) count++;
    return count;
  };

  return (
    <div className="p-4">
      <Dialog
        open={isOpenFilter}
        onClose={() => setIsOpenFilter(false)}
        className="fixed inset-0 flex items-center justify-center p-4 bg-black/50"
      >
        <Dialog.Panel className="w-full max-w-xl p-6 bg-white rounded-lg shadow-lg max-h-[90vh] overflow-y-auto">
          <div className="mb-4">
            <div className="flex justify-between items-center">
              <Dialog.Title className="text-base font-semibold text-black">
                Filter By:
              </Dialog.Title>
              <button
                onClick={() => setIsOpenFilter(false)}
                className="text-gray-500 hover:text-black text-base font-bold leading-none"
              >
                &times;
              </button>
            </div>

            <div className="flex justify-end items-center gap-4 mt-2 text-sm text-gray-600">
              <span>{getFilterCount()} filters selected</span>

              <button
                onClick={handleClearFilters}
                className="flex items-center gap-1 text-blue-600 hover:underline"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                  />
                </svg>
                Clear all
              </button>
            </div>
          </div>

          {/* Date Range Selection */}
          <div className="mt-4">
            <label className="font-medium block mb-2">Select Date Range</label>
            <div className="flex flex-wrap gap-4 mb-2">
              {quickRanges.map((range) => (
                <label key={range.value} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="rangeType"
                    value={range.value}
                    checked={rangeType === range.value}
                    onChange={() => handleQuickRange(range.value)}
                    className="w-3 h-3 appearance-none border-2 border-primary rounded-full checked:bg-primary checked:ring-2 checked:ring-primary checked:ring-offset-2"
                  />
                  {range.label}
                </label>
              ))}
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="rangeType"
                  value="custom"
                  checked={rangeType === "custom"}
                  onChange={() => setRangeType("custom")}
                  className="w-3 h-3 appearance-none border-2 border-primary rounded-full checked:bg-primary checked:ring-2 checked:ring-primary checked:ring-offset-2"
                />
                Custom range
              </label>
            </div>
            {rangeType === "custom" && (
              <div className="flex items-center gap-2">
                <input
                  type="date"
                  value={filters.dateRange.start}
                  onChange={(e) => handleDateChange(e, "start")}
                  className="border rounded-md p-2"
                />
                <span>to</span>
                <input
                  type="date"
                  value={filters.dateRange.end}
                  onChange={(e) => handleDateChange(e, "end")}
                  className="border rounded-md p-2"
                />
              </div>
            )}
          </div>

          {/* Verification Filter */}
          {isAdmin && (
            <div className="mt-4">
              <label className="font-medium">Verification</label>
              <div className="flex flex-col mt-1 gap-2">
                {["done", "not_done"].map((option) => (
                  <label
                    key={option}
                    className="flex items-center gap-2 cursor-pointer"
                  >
                    <span className="relative w-5 h-5">
                      <input
                        type="checkbox"
                        checked={filters.verification === option}
                        onChange={() =>
                          setFilters({
                            ...filters,
                            verification:
                              filters.verification === option ? "" : option,
                          })
                        }
                        className="w-5 h-5 appearance-none border-2 border-primary rounded-sm
                               checked:bg-transparent transition duration-200"
                      />
                      {filters.verification === option && (
                        <svg
                          className="absolute inset-0 m-auto w-4 h-4 text-primary pointer-events-none"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      )}
                    </span>
                    {option === "done" ? "Done" : "Not done"}
                  </label>
                ))}
              </div>
            </div>
          )}

          {/* Token Filter */}
          <div className="mt-4">
            <label className="font-medium">Token</label>
            <div className="flex flex-col mt-1">
              {["received", "pending"].map((option) => (
                <label
                  key={option}
                  className="flex items-center gap-2 cursor-pointer"
                >
                  <span className="relative w-5 h-5">
                    <input
                      type="checkbox"
                      checked={filters.token === option}
                      onChange={() =>
                        setFilters({
                          ...filters,
                          token: filters.token === option ? "" : option,
                        })
                      }
                      className="w-5 h-5 appearance-none border-2 border-primary rounded-sm
                               checked:bg-transparent transition duration-200"
                    />
                    {filters.token === option && (
                      <svg
                        className="absolute inset-0 m-auto w-4 h-4 text-primary pointer-events-none"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    )}
                  </span>
                  {option === "received" ? "Received" : "Pending"}
                </label>
              ))}
            </div>
          </div>

          {/* Installation Filter */}
          {filters.token === "received" && isAdmin && (
            <div className="mt-4">
              <label className="font-medium">Installation</label>
              <div className="flex flex-col mt-1">
                {installationOptions.map((option) => (
                  <label
                    key={option}
                    className="flex items-center gap-2 cursor-pointer"
                  >
                    <span className="relative w-5 h-5">
                      <input
                        type="checkbox"
                        checked={filters.installationStatus === option}
                        onChange={() =>
                          setFilters({
                            ...filters,
                            installationStatus:
                              filters.installationStatus === option
                                ? ""
                                : option,
                          })
                        }
                        className="w-5 h-5 appearance-none border-2 border-primary rounded-sm
                               checked:bg-transparent transition duration-200"
                      />
                      {filters.installationStatus === option && (
                        <svg
                          className="absolute inset-0 m-auto w-4 h-4 text-primary pointer-events-none"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      )}
                    </span>
                    {option}
                  </label>
                ))}
              </div>
            </div>
          )}
          {/* Action Buttons */}
          <div className="mt-6 flex justify-end">
            <button
              onClick={() => setIsOpenFilter(false)}
              className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark"
            >
              Apply Filter
            </button>
          </div>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}
